// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".absolute[data-v-214d2010]{position:absolute !important;top:0;left:0}.splitHeader section[data-v-214d2010]{position:relative;width:100vw;padding:20px}.splitHeader section h1[data-v-214d2010]{position:relative;font-size:1.5rem;color:#fff}.splitHeader section h4[data-v-214d2010]{font-size:1.2rem;line-height:1.5;color:#fff;z-index:100}", ""]);
// Exports
module.exports = exports;
